import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import AgentChip from './AgentChip';
import Confidence from './Confidence';
import { X, Loader2, RefreshCw, Check, Download, FileText } from 'lucide-react';
import { toast } from '../lib/aiToast';

// Reusable "agent generated a document" drawer: shows a generating shimmer,
// then an editable draft with Regenerate / Approve & submit (HITL).
export default function ArtifactModal({ open, onClose, title, agent = 'comms', generate, submitLabel = 'Approve & submit', onSubmit }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setBusy(true); setText('');
    const t = setTimeout(() => { setText(typeof generate === 'function' ? generate() : generate || ''); setBusy(false); }, 850);
    return () => clearTimeout(t);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;

  const regen = () => { setBusy(true); setTimeout(() => { setText(typeof generate === 'function' ? generate() : text); setBusy(false); toast.message('Regenerated'); }, 700); };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-sm" />
      <div className="relative w-full max-w-2xl dh-card-flush shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-3.5 border-b border-slate-100 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="h-8 w-8 rounded-lg bg-violet-50 text-violet-600 flex items-center justify-center"><FileText className="h-4 w-4" /></div>
            <div>
              <div className="text-sm font-semibold text-slate-900">{title}</div>
              <div className="flex items-center gap-2 mt-0.5"><AgentChip agent={agent} size="xs" />{!busy && <Confidence value={0.88} label="draft" />}</div>
            </div>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700"><X className="h-5 w-5" /></button>
        </div>

        <div className="p-5 overflow-y-auto flex-1">
          {busy ? (
            <div className="space-y-2.5">
              <div className="flex items-center gap-2 text-sm text-violet-600 mb-3"><Loader2 className="h-4 w-4 animate-spin" />Drafting…</div>
              {[...Array(8)].map((_, i) => <div key={i} className="relative h-3 rounded bg-slate-100 overflow-hidden dh-shimmer" style={{ width: `${[92, 78, 85, 60, 88, 72, 95, 40][i]}%` }} />)}
            </div>
          ) : (
            <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={16} className="text-sm font-mono leading-relaxed" />
          )}
        </div>

        <div className="px-5 py-3 border-t border-slate-100 flex items-center justify-between">
          <Button variant="ghost" size="sm" onClick={regen} disabled={busy}><RefreshCw className="h-4 w-4 mr-1.5" />Regenerate</Button>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={() => toast.success('Downloaded PDF')} disabled={busy}><Download className="h-4 w-4 mr-1.5" />PDF</Button>
            <Button size="sm" className="bg-brand-600 hover:bg-brand-700 text-white" disabled={busy} onClick={() => { onSubmit?.(text); onClose(); }}><Check className="h-4 w-4 mr-1.5" />{submitLabel}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
